// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yuKlj","selected":"styles_selected__3rE4u"};